import {ProcessStatus, ShoppingSubscriptionState} from './interfaces'

export const getInitialState = (): ShoppingSubscriptionState => {
    return {
        reservedId: null,
        processStatus: ProcessStatus.IDLE,
        firstDeliveryDate: '',
        firstPaymentDate: '',
        periodType: 'ONCE_PER_FOUR_WEEK',
        periodCount: 0,
        paymentMethodSeqNo: null,
        selectableMaxPeriodCount: null,
        isImmediatePayment: false,
        isImmediatePaymentSuccess: false,
    }
}
